import React, { useEffect } from 'react';
import { observer } from "mobx-react";
import 'react-toastify/dist/ReactToastify.css';

import { Layout } from '../components/Layout';
import store from '../components/Stores/SurveyStore';
import PrivateRoute from '../Routing/PrivateRoute'
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer'
import SurveyPage from '../components/SurveyPage';

import PreviousYearDataPanel from '../components/PreviousYearDataPanel';
import SubsectionPanel from '../components/SubsectionPanel'

//Common Pages
import GenericHomePage from '../components/GenericHomePage';

//Modals
import HelpModal from "../components/Modals/HelpModal"
import AddCommentModal from "../components/Modals/AddCommentModal"
import AddExplanationModal from "../components/Modals/AddExplanationModal"

import { LoadPABSSurvey } from '../control';

import { ElementType } from '../Enums/constants';
import { ToastContainer, Slide } from 'react-toastify';

import LogoutConfirmModal from '../components/Modals/LogoutConfirmModal';
import SurveyLoadingScreen from '../components/SurveyLoadingScreen';


const Home = () => {
    //console.log('rendering start again')

    return (
        <SurveyPage  style={{ paddingLeft: '13%'}}>
            <SurveyTitleArea labelText="BenchmarkNl Home" />
            <SurveyContentContainer>
                <GenericHomePage />
            </SurveyContentContainer>

        </SurveyPage>
    );
};

function Fondsinformatie() {
    //console.log('rendering start again')
    return (
        <SurveyPage>
            <SurveyTitleArea labelText="FondsInformatie" />
            <SurveyContentContainer>

                <SurveySection labelText="Contact Informatie">
                    <SurveyElement labelText="Beantwoord de volgende vragen:" />
                    <SurveyElement labelText="Naam pensioenfonds" inputType={ElementType.TEXT} name="Longname" subQuestion={true} />

                    <SurveyElement labelText="Contactpersoon vragenlijst" inputType={ElementType.TEXT} name="Name" subQuestion={true} />
                    <SurveyElement labelText="Telefoonnummer" inputType={ElementType.TEXT} name="Telephone" subQuestion={true} />
                    <SurveyElement labelText="E-mail voor vragenlijst" inputType={ElementType.TEXT} name="Email" subQuestion={true} />
                    <SurveyElement labelText="Contactpersoon rapport" inputType={ElementType.TEXT} name="ContactReport" subQuestion={true} />
                    <SurveyElement labelText="E-mail voor rapport" inputType={ElementType.TEXT} name="EmailContactReport" subQuestion={true} />
                </SurveySection>

                <SurveySection labelText="Aantallen deelnemers">
                    <SurveyElement labelText="Stand per 31-12-2019:" />
                    <SurveyElement labelText="Actieve deelnemers?" inputType={ElementType.NUMBER} name="ActiveMembers" subQuestion={true}/>
                    <SurveyElement labelText="Gewezen deelnemers?" inputType={ElementType.NUMBER} name="InactiveMembers" subQuestion={true} />
                    <SurveyElement labelText="Telefoonnummer" inputType={ElementType.NUMBER} name="Annuitants" subQuestion={true} />
                </SurveySection>

                <SurveySection labelText="Fonds karakteristieken">
                    <SurveyElement labelText="Welke van de volgende omschrijvingen beschrijft het best de verplichte pensioenregelingen die u uitvoert voor ieder van uw deelnemersgroepen?"  />
                    <SurveyElement labelText="Uitkeringsovereenkomst (Defined Benefit, DB)?" inputType={ElementType.NUMBER} name="Q_226aYN" subQuestion={true} />
                    <SurveyElement labelText="Collective Defined Contribution ('CDC')?" inputType={ElementType.NUMBER} name="CollectiveDC" subQuestion={true} />
                    <SurveyElement labelText="Premieovereenkomst (Defined Contribution, DC)?" inputType={ElementType.NUMBER} name="Q_226gYN" subQuestion={true} />
                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.NUMBER} name="Q_226iYN" subQuestion={true} />

                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.TEXTAREA} name="Q_226iDescr" subQuestion={true} dependentQuestion="Q_226iYN" desiredValue="Ja"/>
                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.NUMBER} name="Q_226iYN" subQuestion={true} />
                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.NUMBER} name="Q_226iYN" subQuestion={true} />

                </SurveySection>

            </SurveyContentContainer>


        </SurveyPage>
    );
}

function Kosten() {
    console.log('rendering start again, benchmarknl')
    return (
        <SurveyPage>
            <SurveyTitleArea labelText="Kosten" />
            <SurveyContentContainer>

                <SurveySection labelText="">
                    <SurveyElement labelText="Uw pensioenbeheerkosten:" />
                    <SurveyElement labelText="Wat waren uw totale pensioenbeheerkosten per uw jaarverslag (in €000en)?" inputType={ElementType.TEXT} name="Q_25" subQuestion={true} />

                    <SurveyElement labelText="Contactpersoon vragenlijst" inputType={ElementType.TEXT} name="InvestmentCosts" subQuestion={true} />
                    <SurveyElement labelText="Telefoonnummer" inputType={ElementType.TEXT} name="OtherAdministrationCost" subQuestion={true} />
                    <SurveyElement labelText="E-mail voor vragenlijst" inputType={ElementType.TEXT} name="Email" subQuestion={true} />
                </SurveySection>

                <SurveySection labelText="Aantallen deelnemers">
                    <SurveyElement labelText="Stand per 31-12-2019:" />
                    <SurveyElement labelText="Actieve deelnemers?" inputType={ElementType.NUMBER} name="ActiveMembers" subQuestion={true} />
                    <SurveyElement labelText="Gewezen deelnemers?" inputType={ElementType.NUMBER} name="InactiveMembers" subQuestion={true} />
                    <SurveyElement labelText="Telefoonnummer" inputType={ElementType.NUMBER} name="Annuitants" subQuestion={true} />
                </SurveySection>

                <SurveySection labelText="Fonds karakteristieken">
                    <SurveyElement labelText="Welke van de volgende omschrijvingen beschrijft het best de verplichte pensioenregelingen die u uitvoert voor ieder van uw deelnemersgroepen?" />
                    <SurveyElement labelText="Uitkeringsovereenkomst (Defined Benefit, DB)?" inputType={ElementType.NUMBER} name="Q_226aYN" subQuestion={true} />
                    <SurveyElement labelText="Collective Defined Contribution ('CDC')?" inputType={ElementType.NUMBER} name="CollectiveDC" subQuestion={true} />
                    <SurveyElement labelText="Premieovereenkomst (Defined Contribution, DC)?" inputType={ElementType.NUMBER} name="Q_226gYN" subQuestion={true} />
                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.NUMBER} name="Q_226iYN" subQuestion={true} />

                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.TEXTAREA} name="Q_226iDescr" subQuestion={true} dependentQuestion="Q_226iYN" desiredValue="Ja" />
                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.NUMBER} name="Q_226iYN" subQuestion={true} />
                    <SurveyElement labelText="Anders (toelichten)?" inputType={ElementType.NUMBER} name="Q_226iYN" subQuestion={true} />

                </SurveySection>

            </SurveyContentContainer>


        </SurveyPage>
    );
}

export const BenchmarkNLSurvey = observer(() => {
    useEffect(() => {
        if (store.currentSurvey == null || store.currentSurvey[0] == null) {
            LoadPABSSurvey();
        }
    }, []);
    if (store.loadingSurvey) {
        return (<SurveyLoadingScreen />);
    }
   
        return (

            <Layout>
                <PrivateRoute exact path='/benchmarknl' component={Home} allowIfPageExists={store.local.start} />
                <PrivateRoute exact path='/benchmarknl/Home' component={Home} allowIfPageExists={store.local.start} />
                <PrivateRoute exact path='/benchmarknl/Fondsinformatie' component={Fondsinformatie} allowIfPageExists={store.local.start} />

                <SubsectionPanel />
                <PreviousYearDataPanel />
                <HelpModal />
                <AddCommentModal />
                <AddExplanationModal />
                <LogoutConfirmModal />
                <ToastContainer transition={Slide} />
            </Layout>
        )
    })
